import TermsHero from "./components/TermsHero";
import TermsContent from "./components/TermsContent";

export default function TermsPage() {
  return (
    <main>
      <TermsHero />
      <TermsContent />
    </main>
  );
}